// Logistics e-mail definitions — single source of truth, shared by the
// view/list field (`transactionConfig.tsx`) and the pipeline field
// (`transactionPipelineFields.tsx`). Kept out of `transactionEmailCells.tsx`
// so that file exports only components (react-refresh/only-export-components).

export interface LogisticsEmailDef {
  type: string;
  label: string;
  checkKey: string;
  canResend: boolean;
}

// Named separately so single-def cells can reference it directly
// instead of a `.find()` the compiler can't prove non-empty.
export const TRANSPORT_ORDER_EMAIL_DEF: LogisticsEmailDef = {
  type: "transport_order", label: "Zlecenie", checkKey: "transport_order_sent_check", canResend: true,
};

// Shared by the view/list field (`transactionConfig.tsx`) and the pipeline
// field (`transactionPipelineFields.tsx`). Every logistics mail is resendable —
// data (driver, plate, dates, carrier) often changes after the first send (#449).
export const LOGISTICS_EMAIL_DEFS: ReadonlyArray<LogisticsEmailDef> = [
  TRANSPORT_ORDER_EMAIL_DEF,
  { type: "loading_notification",    label: "Awizacja załadunku",  checkKey: "loading_notification_sent_check",    canResend: true },
  { type: "unloading_notification",  label: "Awizacja rozładunku", checkKey: "unloading_notification_sent_check",  canResend: true },
  { type: "unload_entry_request",    label: "Wjazdówka",           checkKey: "unload_entry_request_sent_check",    canResend: true },
];
